<script>import ButtonBox from "./ButtonBox.svelte";
import { attrValue } from "../../../../utils/html";
export let props = {};
$: props = {
  ...props,
  classNames: attrValue([props.classNames, "bg-primary text-white"])
};
</script>

<ButtonBox {...$$restProps} {props} on:click>
	<slot />
</ButtonBox>
